import * as zod from 'zod';

import { CartesianPose } from '@sb/geometry';
import { CollisionBoxConfig } from '@sb/integrations/types/CollisionBox';

import { getDefaultTCPTransform } from '../constants';

export const Robotiq2FModelVariant = zod.enum(['2F-85', '2F-140']);

const DEFAULT_VARIANT: zod.infer<typeof Robotiq2FModelVariant> = '2F-140';

export const Robotiq2FConfiguration = zod.object({
  kind: zod.literal('Robotiq2F'),
  name: zod.string().default('2F'),
  modelVariant: Robotiq2FModelVariant.default(DEFAULT_VARIANT),
  defaultSpeedMetersPerSecond: zod.number().nonnegative(),
  defaultForceNewtons: zod.number().nonnegative(),
  fingerWidthMeters: zod.number().nonnegative().default(0),
  tcpTransform: CartesianPose.default(getDefaultTCPTransform(DEFAULT_VARIANT)),
  collisionBox: CollisionBoxConfig.optional(),
});

export type Robotiq2FConfiguration = zod.infer<typeof Robotiq2FConfiguration>;
